import './field.scss';
import type { FieldProps } from '../../types';
import { CopyToClipboardButton, PanelActionButton } from '../../components';
import { useState } from 'react';

export default function Field(props: React.PropsWithChildren<FieldProps>) {

	const [editMode, setEditMode] = useState(false);

	const handleEdit = () => {
		setEditMode(true);
	};

		return (
			(props.visible ?? true) ?
				<div className={'dx-field' + (props.vertical ? ' vertical' : '') + (!!props.className ? ' ' + props.className : '')}>
					<div className='dx-field-label'>
						{props.label + (props.label && !props.vertical ? ':' : '')}
						{props.isRequired && <span className="required-indicator"> *</span>}
					</div>
				<div className={'dx-field-value-static' + (props.multiline ? ' multiline' : '')}>
					{(props.allowEdit === undefined || !props.allowEdit || !editMode) && 
						props.children}
					{(props.allowEdit !== undefined && props.allowEdit && !editMode) && 
						<PanelActionButton title="Edit" icon="dx-icon-edit" action={handleEdit} />}
					{(props.allowEdit !== undefined && props.allowEdit && editMode) && 
						props.editControl}
					{(props.showCopyToClipboard && (props.children?.toString() ?? '') !== '') && 
						<CopyToClipboardButton text={props.children?.toString() ?? ''} title={props.label} />}
				</div>
			</div>
			:
			<></>
	);
}
